import { DefaultPickService, canvasAllocate } from "@visactor/vrender-core";

export class DefaultCanvasPickerService extends DefaultPickService {
    constructor(contributions, drawContribution, pickItemInterceptorContributions, pickServiceInterceptorContributions) {
        super(pickItemInterceptorContributions, pickServiceInterceptorContributions), this.contributions = contributions, 
        this.drawContribution = drawContribution, this.pickItemInterceptorContributions = pickItemInterceptorContributions, 
        this.pickServiceInterceptorContributions = pickServiceInterceptorContributions, 
        this.global.hooks.onSetEnv.tap("canvas-picker-service", ((_, env, global) => {
            this.configure(global, env);
        })), this.configure(this.global, this.global.env), this.pickerMap = new Map, this.init();
    }
    init() {
        this.contributions.getContributions().forEach((item => {
            this.pickerMap.set(item.numberType, item);
        })), super._init();
    }
    configure(global, env) {
        this.pickCanvas = canvasAllocate.shareCanvas(), this.pickContext = this.pickCanvas.getContext("2d");
    }
    pickItem(graphic, point, parentMatrix, params) {
        if (!1 === graphic.attribute.pickable) return null;
        if (this.InterceptorContributions.length) for (let i = 0; i < this.InterceptorContributions.length; i++) {
            const drawContribution = this.InterceptorContributions[i];
            if (drawContribution.beforePickItem) {
                const ret = drawContribution.beforePickItem(graphic, this, point, params, {
                    parentMatrix: parentMatrix
                });
                if (ret) return ret;
            }
        }
        const picker = this.pickerMap.get(graphic.numberType);
        if (!picker) return null;
        const pd = picker.contains(graphic, point, params), g = pd ? graphic : null, data = {
            graphic: g,
            params: pd
        };
        if (g) return data;
        if (this.InterceptorContributions.length) for (let i = 0; i < this.InterceptorContributions.length; i++) {
            const drawContribution = this.InterceptorContributions[i];
            if (drawContribution.afterPickItem) {
                const ret = drawContribution.afterPickItem(graphic, this, point, params, {
                    parentMatrix: parentMatrix
                });
                if (ret) return ret;
            }
        }
        return data;
    }
}
//# sourceMappingURL=canvas-picker-service.js.map